export default __webpack_public_path__ + "static/media/ionics.f3ecd962.svg";